import { render, staticRenderFns } from "./MailIcon.vue?vue&type=template&id=42889e02&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42889e02', component.options)
    } else {
      api.rerender('42889e02', component.options)
    }
    module.hot.accept("./MailIcon.vue?vue&type=template&id=42889e02&functional=true&", function () {
      api.rerender('42889e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/MailIcon.vue"
export default component.exports